<template>
  <div
    :style="{
      background: bgColor
    }"
    class="ocr"
  >
    <!-- <div>{{ innerText }}</div> -->
    <!-- <button @click="init">点击进行活体验证</button> -->
    <div id="videoParent"></div>
  </div>
</template>
<script>
import { getFaceToken, faceVerify } from '@/api/home'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      rtcVideo: {},
      innerText: '',
      bizToken: '',
      bgColor: '',
      userInfo: {
        idNo: '',
        name: ''
      }
    }
  },
  created() {
    this.userInfo.name = this.$route.query.name
    this.userInfo.idNo = this.$route.query.no
    this.getFaceToken()
  },
  methods: {
    getFaceToken() {
      getFaceToken({
        username: 'aaa',
        idNo: this.userInfo.idNo,
        name: this.userInfo.name
      }).then(res => {
        console.log(res)
        this.bizToken = res.body.bizToken
        this.init()
      })
    },
    faceVerify() {
      const params = {
        username: 'aaa',
        bizToken: this.bizToken,
        idNo: this.userInfo.idNo,
        name: this.userInfo.name
      }
      faceVerify(params).then(res => {
        console.log(res)
        if (res.ret == '00') {
          // code 1 成功 2 失败
          wx.miniProgram.redirectTo({
            url:
              '/pagesMy/pages/certification/face?code=1&imgUrl=' +
              encodeURIComponent(res.body.imgUrl)
          })
        } else {
          // code 1 成功 2 失败
          wx.miniProgram.redirectTo({
            url:
              '/pagesMy/pages/certification/face?code=2&msg=' +
              encodeURIComponent(res.msg)
          })
        }
      })
    },
    initMedia() {
      // 兼容性媒体功能
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          var getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia ||
            navigator.oGetUserMedia
          if (!getUserMedia) {
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop()
        })
      }
    },
    init() {
      this.rtcVideo = new RctVideo({
        videoWrapper: 'videoParent', //页面中镶嵌video元素的位置
        width: '320px',
        height: '320px',
        token: this.bizToken, //用户服务器端请求getToken返回的token
        colorListener: (color, status, index, sum) => {
          console.log(color, status, index, sum)
          this.bgColor = color
          if (status == 'COLORING') {
            this.innerText = `当前颜色为第${index}: ${color}, 共${sum}个，状态为${status}`
          } else {
            this.innerText = `当前颜色为第${color}，状态为${status}`
          }
        }, //传递color给用户，用户监听color变化，修改页面背景颜色
        tipListener: (tipCode, tipTxt) => {
          console.log(tipCode, tipTxt)
          this.innerText = tipTxt
        }, //提示语信息
        statusListener: data => {
          this.innerText = data
          console.log(data, 'statusListener')
          if (data == 'DISCONNECTED') {
            wx.miniProgram.redirectTo({
              url:
                '/pagesMy/pages/certification/face?code=2&msg=' +
                encodeURIComponent('活体检测超时，请重试')
            })
          }
        }, //状态的改变，需要调用方对各个状态做相应处理
        successCallback: data => {
          console.log(data, 'successCallback')
          console.log('采集完成，允许请求结果')
          this.faceVerify()
        }, //验证完毕后，回调
        failCallback: data => {
          console.log(data, 'failCallback')
          console.log(`失败，错误代码为:${data}`)
          // let txt = '活体检测失败，请重试，设备不支持webrtc活体检测'
          let txt = '当前微信版本过低，请升级为最新版本或至App认证'
          if (data == 'TIMEOUT') {
            txt = 'TIMEOUT-检测超时，请稍后再试或至App认证'
          } else if (data == 'TOKEN_CHECKCODE_UPLOAD_TOOMANY') {
            txt = 'CHECKCODE-检测次数过多,请稍后再试或至App认证'
          } else if (data == 'TOKEN_EXPIRED') {
            txt = 'EXPIRED-尝试检测失败,请稍后再试或至App认证'
          } else if (data == 'NOT_SUPPORT_WEBRTC') {
            txt = 'NOT_SUPPORT-设备不支持webrtc活体检测请至App认证'
          } else if (data == 'REJECT_MEDIA') {
            txt = 'REJECT_MEDIA-请确认是否开启摄像头权限或至App认证'
          } else if (data == 'NOT_GET_STREAM') {
            txt = 'NOT_STREAM-设备不支持webrtc活体检测请至App认证'
          }
          wx.miniProgram.redirectTo({
            url:
              '/pagesMy/pages/certification/face?code=2&msg=' +
              encodeURIComponent(txt)
          })
        } // webrtc初始化不支持或中途不支持情况降级回调
      })

      this.rtcVideo.start()
    }
  }
}
</script>
